<template>
  <div>
    <!-- <v-toolbar flat class="editBG">
      <v-toolbar-title class="elevation-0">Selections</v-toolbar-title> -->
    <!-- <v-divider class="mx-2" inset vertical></v-divider> -->
    <!-- <v-spacer></v-spacer> -->
    <!-- </v-toolbar> -->

    <v-dialog v-model="view_dialog" width="900">
      <v-card class="rounded-card">
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ oldNew }} value preview
        </v-card-title>

        <v-card-text v-html="view"> </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="view_dialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="restore_dialog" max-width="490">
      <v-card class="rounded-card px-2">
        <v-card-title
          class="headline"
          v-if="
            artwork[journal_to_restore.value_name] ==
              journal_to_restore[version_to_restore]
          "
          >Current value is the same as the value you want to replace field
          with.</v-card-title
        >
        <v-card-title class="headline" v-else
          >Are you sure to restore this field's value?</v-card-title
        >

        <v-card-text>
          <!-- Field to modify: {{journal_to_restore.value_name.split('_').join(' ')}}<br /> -->
          Current value: <br /><b>{{ artwork[journal_to_restore.value_name] }}</b><br /><br />
          Restore this value: <br /><b>{{ journal_to_restore[version_to_restore] }}</b><br />
        </v-card-text>

        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>

          <v-btn color="black darken-1" outline @click="restore_dialog = false">
            Cancel
          </v-btn>

          <v-btn dark  @click="restore_dialog = false">
            Proceed
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar-title class="elevation-0 ml-4 pt-3 pb-0">
      <!-- <v-spacer></v-spacer> -->
        History of changes of this Artwork
    </v-toolbar-title>

    <v-card-title>
      <v-layout row mt-3 mx-2>
        <span>
          <v-menu
            offset-y
            :close-on-content-click="true"
            class="text-xs-left mx-0 my-0 py-0 align-left"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                small
                icon
                color="black"
                dark
                v-on="on"
                class="text-xs-right mx-0 mt-2 my-0 py-0"
              >
                <v-icon small>supervisor_account</v-icon>
              </v-btn>
            </template>
            <v-list value="1">
              <v-list-tile
                v-for="(header, index) in headers"
                :key="index.id"
                @click="changeSort(header.value)"
              >
                <v-list-tile-title>{{ header.text }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </span>
        <span class="text-xs-left mt-1 pt-2 ml-3 subheading">
          {{ selectedSorting.toUpperCase().split("_").join(" ") }}
        </span>
      </v-layout>

      <v-spacer></v-spacer>
      <v-text-field
        class="mr-3"
        append-icon="search"
        label="Search "
        single-line
        clearable
        hide-details
        v-model="search"
      ></v-text-field>
    </v-card-title>

      <!-- :headers="headers" -->
      <!-- hide-headers -->
    <v-data-table
      :search="search"
      :items="journals_store"
      item-key="id"
      class="elevation-1 mx-4"
      v-model="selected"
      :pagination.sync="p"
    >

      <template v-slot:headers="props">
        <v-layout row wrap class="my-2">
          <v-flex xs3 pl-4>
            Change date/Author/Field
          </v-flex>
          <v-flex xs4 pl-2>
            Old Value/Restore/Copy value
          </v-flex>
          <v-flex xs5 pl-2>
            New Value/Restore/Copy value
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
          <!-- <div
            v-for="header in props.headers"
            :key="header.text"
            :class="['column sortable', p.descending ? 'desc' : 'asc', header.value === p.sortBy ? 'active' : '']"
            @click="changeSort(header.value)"
          >
            <v-icon small>arrow_upward</v-icon>
            {{ header.text }}
          </div> -->
        </tr>
      </template>
      
      <template slot="items" slot-scope="props">
        <td
          colspan="6"
          style="width: 100%; padding:0px; margin:0px; height: 100px !important;"
        >
          <v-layout row wrap class="mx-0">
            <v-flex class="subheading py-3 pl-4 text-xs-left xs3">
              <b class="body-2">{{ format_date(props.item.created_at) }}</b
              ><br />
              <small v-if="props.item.user_id"
                >{{ get_abb(props.item.user_id) }} in
                {{ props.item.cms.toUpperCase() }} CMS</small
              ><br />
              <span>{{ props.item.value_name.split("_").join(" ") }}</span>
              <!-- <v-checkbox
                class="mt-3"
                primary
                hide-details
                v-model="props.selected"
              ></v-checkbox> -->
            </v-flex>

            <v-flex class="xs4">
              <v-layout row wrap class="content pr-3">
                <v-flex class="xs1 pt-2">

                  <v-btn
                    class="ml-0 pl-0 mt-0 pt-0"
                    icon small
                    :disabled="!props.item.old_value"
                    @click="viewText(props.item.old_value, 'Old')"
                    ><v-icon
                      :color="props.item.old_value ? 'black' : 'grey'"
                      small
                      >remove_red_eye</v-icon
                    ></v-btn
                  ><br />

                  <v-btn v-if="c_user.edit"
                    class="ml-0 pl-0 mt-0 pt-0"
                    icon small
                    :disabled="!props.item.old_value"
                    @click="restoreValue(props.item, 'old_value')"
                    ><v-icon color="black" small
                      >settings_backup_restore</v-icon
                    ></v-btn
                  ><br />

                  <v-btn
                    class="ml-0 pl-0 mt-0 pt-0"
                    color="primary"
                    flat icon small
                    :disabled="!props.item.old_value"
                    @click="copy2c(props.item.old_value)"
                    small icon
                  >
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>
                </v-flex>

                <v-flex xs11 pt-2 mt-1 pl-2>
                  <span
                    class="multi-line"
                    v-html="
                      props.item.old_value == null
                        ? ' &nbsp; &nbsp; &nbsp; '
                        : value2string(props.item.old_value, props.item.value_name)
                    "
                  ></span>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex class="xs5">
              <v-layout row wrap class="content pr-3">
                <v-flex class="xs1 pt-2">

                  <v-btn
                    small
                    class="ml-0 pl-0 mt-0 pt-0"
                    :disabled="!props.item.new_value"
                    icon
                    @click="viewText(props.item.new_value, 'New')"
                    ><v-icon
                      :color="props.item.new_value ? 'black' : 'grey'"
                      small
                      >remove_red_eye</v-icon
                    ></v-btn
                  ><br />

                  <v-btn
                    class="ml-0 pl-0 mt-0 pt-0"
                    :disabled="!props.item.new_value"
                    icon
                    small
                    @click="restoreValue(props.item, 'new_value')"
                    ><v-icon color="black" small
                      >settings_backup_restore</v-icon
                    ></v-btn
                  >
                  
                  <v-btn
                    class="ml-0 pl-0 mt-0 pt-0"
                    color="primary"
                    flat icon small
                    :disabled="!props.item.new_value"
                    @click="copy2c(props.item.new_value)"
                    small icon
                  >
                    <v-icon small>mdi-content-copy</v-icon>
                  </v-btn>

                </v-flex>
                <v-flex xs11 pt-2 mt-1 pl-2>
                  <span
                    class="multi-line"
                    v-html="
                      props.item.new_value == null
                        ? ' &nbsp; &nbsp; &nbsp; '
                        : value2string(props.item.new_value, props.item.value_name)
                    "
                  ></span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </td>
      </template>

      <template slot="no-data">
        <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
        <center>No data available</center>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from '@/utils/apiClient'
function dynamicSort (property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    var result =
      a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}
export default {
  // mixins: [ CommonMixin ],
  created () {
    this.selectedSorting = 'created_at'
    this.getJournals()
    // this.journals_store = this.$store.state.journals.filter(
    //   j => j.journaled_id == this.artwork.id
    // );
  },
  props: ['artwork'],
  data: () => ({
    selectedSorting: 'created_at',
    restore_dialog: false,
    journal_to_restore: '',
    version_to_restore: '',
    view: '',
    oldNew: '',
    view_dialog: false,
    journals_store: [],
    selected: [],
    search: '',
    menu_storage_out: false,
    menu_storage_in: false,
    dialog: false,
    deleteDialog: false,
    itemToDelete: null,
    dialog2: false,
    headers: [
      { text: 'Date', align: 'left', sortable: true, value: 'created_at' },
      {
        text: 'CMS',
        align: 'left',
        sortable: true,
        value: 'cms'
      },
      {
        text: 'Changed by',
        align: 'left',
        value: 'created_by',
        sortable: true
      },
      { text: 'Field', align: 'left ', sortable: true, value: 'value_name' },
      {
        text: 'Old value',
        align: 'left',
        value: 'old_value',
        sortable: true
      },
      {
        text: 'New value',
        align: 'left',
        value: 'new_value',
        sortable: true
      }
      // { text: "Actions", align: "right", sortable: false, align: "center" }
    ],
    editedIndex: -1,
    show: false,
    showUpload: false,
    p: {
      descending: true,
      rowsPerPage: 10,
      sortBy: 'created_at'
    }
  }),
  computed: {
    selections () {
      return this.$store.state.lists.filter(s =>
        s.artworks.includes(this.artwork.id)
      )
    },
    // visa_status () {
    //   this.constants.VISA_STATUSES.find(this.artwork.visa_status)
    // },
    all_packings () {
      return this.$store.state.packings
      // console.log(todos)
      // return todos
    },
    // selection_items () {
    //   var artworkLocations = Object.assign([], this.$store.getters.current_locations)
    //   return artworkLocations.sort(dynamicSort('name'))
    // }
  },
  methods: {
    changeSort (column) {
      this.selectedSorting = column
      if (this.p.sortBy === column) {
        this.p.descending = !this.p.descending
      } else {
        this.p.sortBy = column
        this.p.descending = false
      }
    },
    copy2c (t) {
      navigator.clipboard.writeText(t).then(
        function () {
          // console.log('Async: Copying to clipboard was successful!');
        },
        function (err) {
          console.error('Async: Could not copy text: ', err)
        }
      )
    },
    getJournals () {
      setTimeout(() => {
        let url = `${this.$globals.apiserver}/journals/index_artwork/${this.artwork.id}.json`
        axios
          .get(url)
          .then(response => {
            this.journals_store = response.data
            this.progress = false
          })
          .catch(error => {
            // console.log(error)
          })
      }, 1000)
    },
    viewText (text, oldNew) {
      this.view = text
      this.oldNew = oldNew
      this.view_dialog = true
    },
    restoreValue (journal, version) {
      this.journal_to_restore = journal
      this.version_to_restore = version
      this.restore_dialog = true
    },
    format_journal_artwork (j) {
      var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      // var u = this.$store.state.users.find(u => u.id == j.user_id)
      // console.log(a)
      if (a) {
        return `${j.class_name}:<b> ${a.title}</b>, ${a.full_name}`
      } else {
        return ''
      }
    },
    format_journal_journal (j) {
      // var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      // var u = this.$store.state.users.find(u => u.id == j.user_id)
      return `"${j.value_name}" changed from "${j.old_value}" to "${j.new_value}`
    },
    format_journal_user (j) {
      // var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      if (j.user_id) {
        var u = this.$store.state.users.find(u => u.id == j.user_id)
        return `${u.firstname} ${u.lastname}`
      } else {
        return 'unknown'
      }
    },
    format_date (date) {
      var moment = require('moment')
      var ndate = new Date(date)
      return moment(ndate).format('YYYY-MM-DD hh:mm')
    },

    newItem () {
      this.dialog = true
      this.packing = {
        packing: '',
        height: '',
        lenght: '',
        width: '',
        weight: '',
        contents: '',
        colli: '',
        visa_status: '',
        artwork_id: '',
        artwork_location_id: ''
      }
    },
    editItem (i) {
      this.packing = {
        packing: '',
        height: '',
        lenght: '',
        width: '',
        weight: '',
        contents: '',
        colli: '',
        visa_status: '',
        artwork_id: '',
        artwork_location_id: ''
      }
      this.saving = false
      this.editing = true
      this.dialog = true
      try {
        this.packing = Object.assign(
          {},
          this.artwork.artwork_packings.find(t => t.id == i.id)
        )
      } catch (error) {
        // console.log(error.message)
      }
    },
    saveField () {
      setTimeout(() => {
        let url = `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`
        axios
          .put(url, {
            field_name: 'transport_history',
            field_value: this.artwork.transport_history
          })
          .then(response => {
            this.progress = false
          })
          .catch(error => {
            // console.log(error)
          })
      }, 1000)
    },
    close () {
      this.dialog = false
    },
    // initialize () {},
    showDeleteDialog (p) {
      this.itemToDelete = p
      this.deleteDialog = true
    },
    deleteItem () {
      // const index = this.artwork.artwork_packings.indexOf(this.itemToDelete)
      var i = this.artwork.artwork_packings.indexOf(this.itemToDelete)
      if (i != -1) {
        this.artwork.artwork_packings.splice(i, 1)
      }
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      this.$store.dispatch('deletePacking', this.itemToDelete)
      this.itemToDelete = null
      this.deleteDialog = false
    },
    cancelDelete () {
      this.deleteDialog = false
      this.itemToDelete = null
    },
    // delete_packing () {},
    get_visa_status (packing) {
      var vss = constants.VISA_STATUSES.filter(
        vs => vs.id === packing.visa_status
      )
      if (vss[0] != undefined) {
        // console.log(vss[0].id)
        return vss[0].id > 0 ? vss[0].name : ''
      } else {
        return ''
      }
    },
    // get_location_name (packing) {
    //   var l = this.$store.state.locations.find(
    //     l => l.id === packing.artwork_location_id
    //   )
    //   return l ? l.name : ''
    // },
    duplicateItem (p) {
      // console.log(p)
      var packing = Object.assign({}, p)
      delete packing.id
      // console.log(this.packing)
      packing.artwork_id = this.artwork.id
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = []
      }
      // this.packing.reject { |k,v| k == :id }
      axios
        .post(`${this.$globals.apiserver}/artwork_packings.json`, {
          packing: packing
        })
        .then(response => {
          this.errors = {}
          this.artwork.artwork_packings.push(response.data)
          this.$store.commit('ADD_PACKING', response.data)
        })
        .catch(error => {
          this.errors = error.response.data
        })
      // console.log(this.packing)
      // this.all_packings.push(this.packing)
      this.showUpload = !this.showUpload
      this.dialog = false
      this.packing = {
        packing: '',
        height: '',
        width: '',
        lenght: '',
        weight: '',
        contents: '',
        note: '',
        visa_status: 0,
        colli: '',
        artwork_location_id: ''
      }
    },
    save () {
      this.saving = true
      this.packing.artwork_id = this.artwork.id
      // this.packing.id = this.findMinMax(this.all_packings)+1
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = []
      }
      // this.artwork.artwork_packings.push(this.packing)
      if (this.editing) {
        let url = `${this.$globals.apiserver}/artwork_packings/${this.packing.id}.json`
        axios
          .put(url, {
            packing: this.packing
          })
          .then(response => {
            this.errors = {}
            this.artwork.artwork_packings = [
              ...this.artwork.artwork_packings.map(item =>
                item.id !== response.data.id
                  ? item
                  : { ...item, ...response.data }
              )
            ]
            this.$store.commit('SAVE_PACKING', response.data)
            this.dialog = false
            this.packing = {
              packing: '',
              height: '',
              width: '',
              lenght: '',
              weight: '',
              contents: '',
              note: '',
              visa_status: 0,
              colli: '',
              artwork_location_id: ''
            }
            this.saving = false
            this.editing = false
          })
          .catch(error => {
            // console.log(error)
            this.save_error = true
          })
      } else {
        axios
          .post(`${this.$globals.apiserver}/artwork_packings.json`, {
            packing: this.packing
          })
          .then(response => {
            this.errors = {}
            this.artwork.artwork_packings.push(response.data)
            this.$store.commit('ADD_PACKING', response.data)
          })
          .catch(error => {
            this.errors = error.response.data
          })
        // console.log(this.packing)
        // this.all_packings.push(this.packing)
        this.dialog = false
        this.packing = {
          packing: '',
          height: '',
          width: '',
          lenght: '',
          weight: '',
          contents: '',
          note: '',
          visa_status: 0,
          colli: '',
          artwork_location_id: ''
        }
      }
    },
    update_multiple () {
      this.updated_packing.artwork_id = this.artwork.id
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = []
      }
      axios
        .get(
          `${this.$globals.apiserver}/artwork_packings/update_multiple.json`,
        {
          updated_packing: this.updated_packing,
          selected: this.selected
        }
        )
        .then(response => {
          this.errors = {}
          this.artwork.artwork_packings = []
          this.artwork.artwork_packings.push(response.data)
          // this.$store.commit('REPLACE_PACKING', response.data)
        })
        .catch(error => {
          this.errors = error.response.data
        })
      this.dialog2 = !this.dialog2
      // this.dialog = false
      this.updated_packing = {
        packing: '',
        height: '',
        width: '',
        length: '',
        weigth: '',
        contents: '',
        note: '',
        visa_status: 0
      }
    }
  }
}
</script>

<style scoped>
.rounded-card{
    border-radius:12px;
}
.multi-line {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;
  /* background-color: #a6a9ab; */
}
.spacer {
  height: 0;
  overflow: hidden;
}
.card {
  min-width: 250px;
}
.content {
  text-overflow: ellipsis;
  overflow: hidden;
}
/* white-space: nowrap; */
/* max-width: 100%; */
/* position: absolute; */
</style>



// WEBPACK FOOTER //
// src/components/artworks/Journals.vue